module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_7_before.jpg
// module id = 1170
// module chunks = 0